<template>
  <div>
    <template v-if="field.type_id=='upload'">
      <template v-if="Array.isArray(getValue())">
        <div v-for="file in getValue()" :key="file.id">
          <img :src="url(file.url)" height="150" width="auto" />
        </div>
      </template>
      <div v-else>
        <img :src="url(getValue().url)" height="150" width="auto" />
      </div>
    </template>
    <template v-else>{{getValue()}}</template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ASSET_DOMAIN } from "../../common/config-local";
export default {
  props: {
    field: {
      type: Object
    }
  },
  data: function() {
    return {
      value: null
    };
  },
  computed: {
    ...mapState("order", {
      order: state => state.order
    })
  },
  methods: {
    getValue() {
      if (!this.value) {
        for (let index = 0; index < this.order.datas.length; index++) {
          const data = this.order.datas[index];
          if (data.block_id == this.field.block_id) {
            this.value = data.value;
          }
        }
      }
      return this.value;
    },
    url(url) {
      return ASSET_DOMAIN + url;
    }
  }
};
</script>